/* The cookie card.

   Shown where Shopify's privacy rules ask for consent (31 regions),
   until the visitor answers. Explains the "I am a" feature, asks for
   permission to measure which pages help which kind of coffee person,
   and says that Instagram, Facebook and Reddit learn when a visit came
   from one of our posts. Answers go to Shopify's Customer Privacy API,
   the same place Shopify's own banner writes them, so every pixel that
   waits on consent keeps working. The footer's "Cookie preferences"
   link opens the Choose view. Words: snippets/os-consent.liquid. */
(function () {
  "use strict";
  var D = document, W = window;
  if (W.__osConsent) return;
  W.__osConsent = 1;

  var C = {};
  try { C = JSON.parse(D.querySelector("[data-os-consent-copy]").textContent); } catch (e) { return; }
  var REDUCED = W.matchMedia && W.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var box = null, demoTimer = 0, demoIx = 0;

  function esc(s) {
    return String(s || "").replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch];
    });
  }

  function withApi(cb) {
    var S = W.Shopify;
    if (S && S.customerPrivacy && S.customerPrivacy.shouldShowBanner) { cb(S.customerPrivacy); return; }
    if (!(S && S.loadFeatures)) return;
    S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      if (!err && W.Shopify.customerPrivacy) cb(W.Shopify.customerPrivacy);
    });
  }

  var BACK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';

  function sw(key, title, text) {
    return '<label class="os-cc__row"><span class="os-cc__rtxt"><b>' + esc(title) + "</b><span>" + esc(text) + "</span></span>" +
      '<input type="checkbox" class="os-cc__sw" data-cc-k="' + key + '"></label>';
  }

  function build() {
    box = D.createElement("section");
    box.className = "os-cc";
    box.hidden = true;
    box.setAttribute("role", "dialog");
    box.setAttribute("aria-label", C.label || "Cookies");
    box.innerHTML =
      '<div class="os-cc__card">' +
        '<div class="os-cc__view" data-cc-view="main">' +
          '<div class="os-cc__demo" aria-hidden="true"><span class="os-cc__dl" data-cc-lead></span><span class="os-cc__dr" data-cc-role></span></div>' +
          '<p class="os-cc__eyebrow">' + esc(C.eyebrow) + "</p>" +
          '<h2 class="os-cc__title">' + esc(C.title) + "</h2>" +
          '<p class="os-cc__body">' + esc(C.body) + "</p>" +
          '<p class="os-cc__body">' + esc(C.body2) + "</p>" +
          '<p class="os-cc__small">' + esc(C.social) + "</p>" +
          '<div class="os-cc__acts">' +
            '<button type="button" class="os-cc__btn os-cc__btn--go" data-cc="allow">' + esc(C.allow) + "</button>" +
            '<button type="button" class="os-cc__btn" data-cc="decline">' + esc(C.decline) + "</button>" +
            '<button type="button" class="os-cc__link" data-cc="choose">' + esc(C.choose) + "</button>" +
          "</div>" +
        "</div>" +
        '<div class="os-cc__view" data-cc-view="prefs" hidden>' +
          '<button type="button" class="os-cc__back" data-cc="back">' + BACK + "<span>" + esc(C.back) + "</span></button>" +
          '<h2 class="os-cc__title">' + esc(C.prefs_title) + "</h2>" +
          '<div class="os-cc__rows">' +
            '<div class="os-cc__row"><span class="os-cc__rtxt"><b>' + esc(C.needed_title) + "</b><span>" + esc(C.needed_text) + "</span></span>" +
              '<span class="os-cc__on">' + esc(C.always_on) + "</span></div>" +
            sw("improve", C.improve_title, C.improve_text) +
            sw("social", C.social_title, C.social_text) +
          "</div>" +
          '<div class="os-cc__acts">' +
            '<button type="button" class="os-cc__btn os-cc__btn--go" data-cc="save">' + esc(C.save) + "</button>" +
            '<button type="button" class="os-cc__btn" data-cc="all">' + esc(C.allow_all) + "</button>" +
          "</div>" +
        "</div>" +
      "</div>";
    D.body.appendChild(box);

    box.addEventListener("click", function (e) {
      var b = e.target.closest("[data-cc]");
      if (!b) return;
      var a = b.getAttribute("data-cc");
      if (a === "allow" || a === "all") answer(true, true);
      else if (a === "decline") answer(false, false);
      else if (a === "choose") view("prefs");
      else if (a === "back") view("main");
      else if (a === "save") {
        answer(box.querySelector('[data-cc-k="improve"]').checked, box.querySelector('[data-cc-k="social"]').checked);
      }
    });
  }

  /* The chip at the top of the card plays through a few roles, so the
     feature the card is talking about is visible before it is read. */
  function demo(step) {
    var list = C.demo || [];
    if (!list.length) return;
    var lead = box.querySelector("[data-cc-lead]"), role = box.querySelector("[data-cc-role]");
    var pair = list[demoIx % list.length];
    if (!step || REDUCED) { lead.textContent = pair[0]; role.textContent = pair[1]; return; }
    var chip = lead.parentNode;
    chip.classList.add("is-out");
    setTimeout(function () {
      lead.textContent = pair[0]; role.textContent = pair[1];
      chip.classList.remove("is-out");
    }, 200);
  }
  function startDemo() {
    clearInterval(demoTimer);
    demoIx = 0; demo(false);
    if (REDUCED) return;
    demoTimer = setInterval(function () { demoIx++; demo(true); }, 2200);
  }

  function view(name) {
    var views = box.querySelectorAll("[data-cc-view]");
    for (var i = 0; i < views.length; i++) views[i].hidden = views[i].getAttribute("data-cc-view") !== name;
    if (name === "prefs") {
      withApi(function (cp) {
        var cur = {};
        try { cur = cp.currentVisitorConsent() || {}; } catch (e) {}
        box.querySelector('[data-cc-k="improve"]').checked = cur.analytics === "yes";
        box.querySelector('[data-cc-k="social"]').checked = cur.marketing === "yes";
      });
    }
    var card = box.querySelector(".os-cc__card");
    card.classList.remove("is-swap"); void card.offsetWidth; card.classList.add("is-swap");
  }

  function open(name) {
    if (!box) build();
    view(name || "main");
    box.hidden = false;
    void box.offsetWidth;
    box.classList.add("is-open");
    if ((name || "main") === "main") startDemo();
  }

  function close() {
    if (!box) return;
    clearInterval(demoTimer);
    box.classList.remove("is-open");
    setTimeout(function () { if (!box.classList.contains("is-open")) box.hidden = true; }, REDUCED ? 0 : 320);
  }

  function answer(improve, social) {
    withApi(function (cp) {
      try {
        cp.setTrackingConsent({ analytics: improve, preferences: improve, marketing: social, sale_of_data: social }, function () {});
      } catch (e) {}
    });
    close();
  }

  /* The footer's "Cookie preferences" link opens the Choose view.
     Caught on the way down, before the footer's own handler would ask
     for Shopify's banner. */
  D.addEventListener("click", function (e) {
    var link = e.target.closest && e.target.closest("#os-cookie-prefs");
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    open("prefs");
  }, true);

  withApi(function (cp) {
    var link = D.getElementById("os-cookie-prefs");
    var show = false;
    try { show = cp.shouldShowBanner(); } catch (e) {}
    var asked = false;
    try { asked = show || cp.currentVisitorConsent().marketing !== ""; } catch (e) {}
    if (link && asked) link.hidden = false;
    if (show) setTimeout(function () { open("main"); }, REDUCED ? 0 : 700);
  });
})();
